export default __webpack_public_path__ + "static/media/company_6.7f8e0277.jpg";